module.exports = __webpack_public_path__ + "static/media/ST4.de1c60c4.jpg";